"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../../utils");
var _constant = require("../../../../constant");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _blockEdit = _interopRequireDefault(require("../../../block-edit"));
var _styled = require("../../../base/styled");
var _styled2 = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var PreferencesItem = function PreferencesItem(_ref) {
  var student = _ref.student,
    viewDiversities = _ref.viewDiversities,
    setShowModal = _ref.setShowModal,
    onClickEdit = _ref.onClickEdit,
    showPrivate = _ref.showPrivate,
    isEdit = _ref.isEdit;
  var industries = student.industries.filter(function (a) {
    return a.added === 1;
  });
  var jobInterests = student.jobsInterest.filter(function (job) {
    return job.added === 1;
  });
  var careers = student.careers.filter(function (career) {
    return career.added === 1;
  });
  var pronouns = (0, _utils.getPronounsLabel)(student.pronouns);
  var homeName = student.internationalHome ? student.countryOfHomeName : student.stateOfHomeName;
  var showAdditional = (isEdit || !(0, _isEmpty.default)(student.additionalInformation)) && (student.includeAdditionalDiversityResume || showPrivate) && viewDiversities;
  var showWork = (isEdit || student.workElegibility.authorized || student.workElegibility.sponsorship || student.workElegibility.work) && (student.includeWorkEligibilityResume || showPrivate) && viewDiversities;
  return /*#__PURE__*/_react.default.createElement(_styled2.Container, null, /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1A_CONTACT_INFO, false);
    },
    title: "Name",
    color: "#53b7c2",
    isEdit: isEdit,
    show: isEdit || student.firstName && student.lastName
  }, /*#__PURE__*/_react.default.createElement(_styled2.Text, null, "".concat(student.firstName, " ").concat(student.lastName))), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1A_CONTACT_INFO, false);
    },
    title: "Permanent Address",
    color: "#53b7c2",
    isEdit: isEdit,
    show: isEdit
  }, homeName && student.cityOfHomeName && /*#__PURE__*/_react.default.createElement(_styled2.Text, null, "".concat(student.cityOfHomeName, ", ").concat(homeName))), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return setShowModal(_constant.modals.EMAIL);
    },
    title: "Primary email address",
    color: "#53B7C2",
    isEdit: isEdit,
    show: isEdit || student.email
  }, /*#__PURE__*/_react.default.createElement(_styled2.Text, null, student.email)), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return setShowModal(_constant.modals.ALTERNATIVE_EMAIL);
    },
    title: "Alternate Email",
    color: "#53B7C2",
    isEdit: isEdit,
    show: isEdit || student.alternativeEmail
  }, /*#__PURE__*/_react.default.createElement(_styled2.Text, null, student.alternativeEmail)), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1A_CONTACT_INFO, false);
    },
    title: "Phone Number",
    color: "#53B7C2",
    isEdit: isEdit,
    show: isEdit || student.phone
  }, /*#__PURE__*/_react.default.createElement(_styled2.Text, null, (0, _utils.getFormatPhone)(student.phone))), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return setShowModal(_constant.modals.PRONOUNS);
    },
    title: "Preferred Pronouns",
    color: "#53B7C2",
    isEdit: isEdit,
    show: isEdit || pronouns
  }, /*#__PURE__*/_react.default.createElement(_styled2.Text, null, pronouns)), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return setShowModal(_constant.modals.EMOJIS);
    },
    title: "Five Emojis",
    color: "#53B7C2",
    isEdit: isEdit,
    show: isEdit || student.myselfEmoji
  }, /*#__PURE__*/_react.default.createElement(_styled2.Text, null, student.myselfEmoji)), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routesV2.LEVEL_1A_CONTACT_INFO, false);
    },
    title: "Linkedin URL",
    color: "#53b7c2",
    isEdit: isEdit,
    show: isEdit || student.linkedInURL
  }, student.linkedInURL && /*#__PURE__*/_react.default.createElement(_styled2.Link, {
    rel: "noopener noreferrer",
    target: "_blank",
    href: "https://linkedin.com/in/".concat(student.linkedInURL)
  }, "linkedin.com/in/".concat(student.linkedInURL))), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routes.DIVERSITY_TO_PROFILE_ADDITIONAL_INFORMATION, false);
    },
    title: "Additional Candidate Information".concat(student.includeAdditionalDiversityResume ? '' : ' (Private)'),
    color: "#53b7c2",
    isEdit: isEdit,
    show: showAdditional
  }, !(0, _isEmpty.default)(student.additionalInformation) && /*#__PURE__*/_react.default.createElement(_styled.List, null, student.additionalInformation.map(function (additionalInformation) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: JSON.stringify(additionalInformation)
    }, additionalInformation.name);
  }))), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routes.DIVERSITY_TO_PROFILE_WORK_ELIGIBILITY, false);
    },
    title: "Work Eligibility".concat(student.includeWorkEligibilityResume ? '' : ' (Private)'),
    color: "#53b7c2",
    isEdit: isEdit,
    show: showWork
  }, !(0, _isEmpty.default)(student.workElegibility) && /*#__PURE__*/_react.default.createElement(_styled.List, null, student.workElegibility.authorized === 1 && /*#__PURE__*/_react.default.createElement("li", {
    key: "authorized"
  }, "I am authorized to work in the United States"), student.workElegibility.sponsorship === 1 && /*#__PURE__*/_react.default.createElement("li", {
    key: "sponsorship"
  }, "Require visa sponsorship"), student.workElegibility.work === 1 && /*#__PURE__*/_react.default.createElement("li", {
    key: "work"
  }, "Able to work part-time or full-time under OPT/CPT"))), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routes.LEVEL_INDUSTRIES, false);
    },
    title: "Industries of Interest",
    color: "#53b7c2",
    isEdit: isEdit,
    show: isEdit || !(0, _isEmpty.default)(industries)
  }, !(0, _isEmpty.default)(industries) && /*#__PURE__*/_react.default.createElement(_styled.List, null, industries.map(function (industry) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: JSON.stringify(industry)
    }, "".concat(industry.industryName, " ").concat(industry.subIndustryName ? "(".concat(industry.subIndustryName, ")") : ''));
  }))), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routes.LEVEL_FUNCTIONS, false);
    },
    title: "Job Functions of Interest",
    color: "#53b7c2",
    isEdit: isEdit,
    show: isEdit || !(0, _isEmpty.default)(jobInterests)
  }, !(0, _isEmpty.default)(jobInterests) && /*#__PURE__*/_react.default.createElement(_styled.List, null, jobInterests.map(function (job) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: JSON.stringify(job)
    }, job.jobName);
  }))), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routes.LEVEL_CAREERS, false);
    },
    title: "Career Keywords of Interest",
    color: "#53b7c2",
    isEdit: isEdit,
    show: isEdit || !(0, _isEmpty.default)(careers)
  }, !(0, _isEmpty.default)(careers) && /*#__PURE__*/_react.default.createElement(_styled.List, null, careers.map(function (career) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: JSON.stringify(career)
    }, career.careerName);
  }))), /*#__PURE__*/_react.default.createElement(_blockEdit.default, {
    onClick: function onClick() {
      return onClickEdit(_constant.routes.LEVEL_SEARCH, false);
    },
    title: "Early Career Resume Template",
    color: "#53b7c2",
    isEdit: isEdit
  }, /*#__PURE__*/_react.default.createElement(_styled2.Text, null, student.seeking ? 'Yes' : 'No')));
};
PreferencesItem.propTypes = {
  student: _utils.studentProps.isRequired,
  onClickEdit: _propTypes.default.func.isRequired,
  setShowModal: _propTypes.default.func.isRequired,
  isEdit: _propTypes.default.bool.isRequired,
  viewDiversities: _propTypes.default.bool.isRequired,
  showPrivate: _propTypes.default.bool.isRequired
};
var _default = PreferencesItem;
exports.default = _default;